import { useSelector } from "react-redux";
import { Unauthorized } from "../pages/unauthorized";
import { modules } from "../api/codes";

export function Authorization({ children, module, perm, page, style }) {
  // if (page) return children;
  // return null;
  const permissions = useSelector((state) => state.user.permissions);
  const freePass = module === modules.Dashboard;
  const isOwner = useSelector((state) => state.user.is_owner) || freePass;

  if (!isAuthorized(permissions, module, perm, isOwner)) {
    if (page) {
      // return children;
      return <Unauthorized />;
    }
    return (
      <div className="no-perm-wrapper" style={style}>
        <div className="no-perm">{children}</div>
      </div>
    );
  }
  return children;
}

export function isAuthorized(permissions, module, perm, isOwner) {
  // return true;

  if (isOwner) {
    return true;
  }

  let ok = false;

  const checkModule = (module, permission) => {
    if (module === permission?.code) {
      permission?.perms?.forEach((pm) => {
        if (pm === perm) {
          ok = true;
        }
        if (Array.isArray(perm)) {
          perm.forEach((p) => {
            if (p === pm) {
              ok = true;
            }
          });
        }
      });
    }
  };

  if (Array.isArray(permissions)) {
    permissions?.forEach((permission) => {
      if (Array.isArray(module)) {
        module.forEach((module) => {
          checkModule(module, permission);
        });
      } else {
        checkModule(module, permission);
      }
    });
  }

  return ok;
}
